import { TextField, TextFieldProps } from '@mui/material';
import { FieldHookConfig, useField } from 'formik';
import { omit } from 'lodash';
import { TestableComponent } from '@/lib/types/ui.types';

export type TTTextFieldProps = {
  disabled?: boolean;
  multiline?: boolean;
  rows?: number;
  required?: boolean;
} & TextFieldProps &
  FieldHookConfig<any> &
  TestableComponent;

export default function TTTextField({ label, ...props }: TTTextFieldProps) {
  const [field, meta] = useField(props);
  const showError = meta.touched && !!meta.error;
  return (
    <TextField
      error={showError}
      helperText={(showError && meta.error) || props.helperText || ' '}
      fullWidth
      label={label}
      variant="standard"
      {...field}
      {...omit(props, ['helperText', 'data-testId'])}
      inputProps={{
        dir: 'auto',
        ...(props['data-testId'] && { 'data-testId': props['data-testId'] }),
        ...props.inputProps,
      }}
    />
  );
}
